/**
 * BEBEFIX THEME — AI Özellikleri
 * Ürün Önerileri, Tahmine Dayalı Arama, Son Görüntülenler
 */

'use strict';

/* ============================================================
   AI ÜRÜN ÖNERİLERİ — Shopify native recommendations API
   ============================================================ */
class AIRecommendations {
  constructor() {
    this.containers = document.querySelectorAll('[data-ai-recommendations]');
    if (!this.containers.length) return;
    this.init();
  }

  async init() {
    for (const container of this.containers) {
      const productId = container.dataset.productId;
      const limit = container.dataset.limit || 4;
      const intent = container.dataset.intent || 'related';

      if (!productId) continue;

      try {
        container.innerHTML = this.renderSkeleton(parseInt(limit));
        const data = await window.Stork.fetchJSON(
          `/recommendations/products.json?product_id=${productId}&limit=${limit}&intent=${encodeURIComponent(intent)}`
        );
        container.innerHTML = this.renderProducts(data.products || []);
      } catch (e) {
        container.innerHTML = '<p class="text-center" style="padding:24px;color:var(--color-text-muted);font-size:14px;">Öneriler şu an yüklenemedi.</p>';
      }
    }
  }

  renderSkeleton(count) {
    return `<div class="product-grid">${Array(count).fill(0).map(() => `
      <div class="skeleton-card">
        <div class="skeleton skeleton-img"></div>
        <div class="skeleton skeleton-text"></div>
        <div class="skeleton skeleton-text-sm"></div>
        <div class="skeleton skeleton-price"></div>
      </div>
    `).join('')}</div>`;
  }

  renderProducts(products) {
    if (!products.length) return '';
    return `<div class="product-grid">${products.map(p => this.renderCard(p)).join('')}</div>`;
  }

  renderCard(p) {
    const escAttr = (s) => String(s ?? '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const escText = (s) => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const img = p.featured_image || '';
    const price = window.Stork.formatMoney(p.price_min);
    const comparePrice = p.compare_at_price_min > p.price_min
      ? `<span class="price--compare">${window.Stork.formatMoney(p.compare_at_price_min)}</span>` : '';
    const salePct = p.compare_at_price_min > p.price_min
      ? Math.round((1 - p.price_min / p.compare_at_price_min) * 100) : 0;
    const isNew = p.tags && (p.tags.includes('yeni') || p.tags.includes('new'));
    const vid = (p.variants && p.variants[0] && p.variants[0].id) ? p.variants[0].id : '';
    const titleAttr = escAttr(p.title);
    const titleHtml = escText(p.title);
    const url = p.url || '#';
    const handle = p.handle || '';
    const mobileAtc = vid ? `
      <button type="button" class="product-card__mobile-atc btn btn-primary btn-sm btn-full" data-pc-atc="${vid}" data-product-title="${titleAttr}">Sepete Ekle</button>` : `
      <button type="button" class="product-card__mobile-atc btn btn-secondary btn-sm btn-full" disabled style="opacity:.6;cursor:not-allowed;">Tükendi</button>`;

    return `
      <div class="product-card" data-product-id="${escAttr(String(p.id))}" data-product-url="${escAttr(url)}">
        <a href="${url}" class="product-card__link-overlay" tabindex="-1" aria-hidden="true"></a>
        <div class="product-card__media">
            <img src="${img ? (typeof portraitProductImg === 'function' ? portraitProductImg(img) : img) : ''}" alt="${titleAttr}" loading="lazy" class="product-card__img product-card__img--main" draggable="false">
          <div class="product-card__badges">
            ${salePct > 0 ? `<span class="badge badge-sale">-%${salePct}</span>` : ''}
            ${isNew ? '<span class="badge badge-new">Yeni</span>' : ''}
          </div>
          <div class="product-card__actions">
            <button type="button" class="product-card__action-btn" data-quick-view="${escAttr(handle)}" aria-label="Hızlı bakış" title="Hızlı Bakış">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
            </button>
            <button type="button" class="product-card__action-btn" data-wishlist-toggle="${p.id}" data-product-title="${titleAttr}" data-product-handle="${escAttr(handle)}" data-product-url="${escAttr(url)}" data-product-image="${escAttr(img)}" data-product-price="${escAttr(price)}" data-variant-id="${escAttr(String(vid))}" aria-pressed="false" aria-label="Favorilere ekle" title="Favorilere Ekle">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
            </button>
          </div>
        </div>
        <div class="product-card__info">
          ${window.Stork?.designGermanyBadgeHtml ? window.Stork.designGermanyBadgeHtml() : ''}
          <div class="product-card__title"><a href="${url}" class="product-card__title-link">${titleHtml}</a></div>
          <div class="product-card__price">
            <span class="price ${salePct > 0 ? 'price--sale' : ''}">${price}</span>
            ${comparePrice}
          </div>${mobileAtc}
        </div>
      </div>
    `;
  }
}

/* ============================================================
   AI ARAMA ÖNERİLERİ
   ============================================================ */
class AISearch {
  constructor() {
    this.input = document.getElementById('SearchInput');
    if (!this.input) return;
    this.resultsEl = document.getElementById('SearchSuggestions');
    this.recentKey = 'bebefix_recent_searches';
    this.blockedRecent = /muffin|buz kalıbı|pasta kalıbı|kalıbı/i;
    window.StorkSearch = this;
    this.init();
  }

  init() {
    this.input.addEventListener('focus', () => {
      if (!this.input.value.trim()) this.showTrending();
    });
  }

  getPopularSuggestions() {
    const el = document.getElementById('SearchPopularData');
    if (!el) return [];
    try {
      const data = JSON.parse(el.textContent || '[]');
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  getRecentSearches() {
    try {
      const recent = JSON.parse(localStorage.getItem(this.recentKey) || '[]');
      if (!Array.isArray(recent)) return [];
      return recent.filter((q) => q && !this.blockedRecent.test(String(q))).slice(0, 3);
    } catch (e) {
      return [];
    }
  }

  escText(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  showTrending() {
    if (!this.resultsEl) return;
    const recent = this.getRecentSearches();
    const popular = this.getPopularSuggestions();
    let html = '';

    if (recent.length) {
      html += '<div class="search-suggestion-title">Son Aramalar</div>';
      html += recent.map((q) => `
        <div class="search-suggestion-item" data-search-query="${this.escText(q)}" style="cursor:pointer">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="color:var(--color-text-muted);flex-shrink:0"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
          <div class="search-suggestion-item__info">
            <div class="search-suggestion-item__title">${this.escText(q)}</div>
          </div>
        </div>
      `).join('');
    }

    if (popular.length) {
      html += '<div class="search-suggestion-title">Popüler Aramalar</div>';
      html += popular.map((item) => {
        const label = item.label || item.query || '';
        const query = item.query || label;
        return `
          <div class="search-suggestion-item" data-search-query="${this.escText(query)}" style="cursor:pointer">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="color:var(--color-primary);flex-shrink:0"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/></svg>
            <div class="search-suggestion-item__info">
              <div class="search-suggestion-item__title">${this.escText(label)}</div>
            </div>
          </div>
        `;
      }).join('');
    } else {
      html += '<div style="padding:10px;font-size:13px;color:var(--color-text-muted);">Öneri bulunamadı. Ürün adı yazarak arayın.</div>';
    }

    this.resultsEl.innerHTML = html;
    this.resultsEl.classList.add('has-results');

    this.resultsEl.querySelectorAll('[data-search-query]').forEach((el) => {
      el.addEventListener('click', () => {
        this.input.value = el.dataset.searchQuery;
        this.input.dispatchEvent(new Event('input', { bubbles: true }));
        this.saveRecent(el.dataset.searchQuery);
      });
    });
  }

  saveRecent(q) {
    if (!q || this.blockedRecent.test(String(q))) return;
    let recent = JSON.parse(localStorage.getItem(this.recentKey) || '[]');
    if (!Array.isArray(recent)) recent = [];
    recent = recent.filter((r) => r && !this.blockedRecent.test(String(r)));
    recent = [q, ...recent.filter((r) => r !== q)].slice(0, 5);
    localStorage.setItem(this.recentKey, JSON.stringify(recent));
  }
}

/* ============================================================
   SON GÖRÜNTÜLENEN ÜRÜNLER
   ============================================================ */
class RecentlyViewed {
  constructor() {
    this.key = 'bebefix_recently_viewed';
    this.container = document.getElementById('RecentlyViewedGrid');
    this.maxItems = 8;
    this.migrateLegacyStorage();
    this.track();
    if (this.container) this.render();
  }

  migrateLegacyStorage() {
    try {
      var legacy = localStorage.getItem('bebefix_viewed');
      if (!legacy || localStorage.getItem(this.key)) return;
      var parsed = JSON.parse(legacy);
      if (!Array.isArray(parsed) || !parsed.length) return;
      var normalized = parsed.map(function (row) {
        return {
          handle: row.handle,
          title: row.title,
          price: row.price,
          img: row.img || row.image || '',
          url: row.url || ''
        };
      });
      localStorage.setItem(this.key, JSON.stringify(normalized));
      localStorage.removeItem('bebefix_viewed');
    } catch (e) {}
  }

  track() {
    const handle = document.body.dataset.productHandle;
    const title = document.body.dataset.productTitle;
    const price = document.body.dataset.productPrice;
    const img = document.body.dataset.productImage;
    const url = document.body.dataset.productUrl;

    if (!handle) return;

    let items = JSON.parse(localStorage.getItem(this.key) || '[]');
    items = [{ handle, title, price, img, url }, ...items.filter(i => i.handle !== handle)].slice(0, this.maxItems);
    localStorage.setItem(this.key, JSON.stringify(items));
  }

  render() {
    const escAttr = (s) => String(s ?? '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const escText = (s) => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const items = JSON.parse(localStorage.getItem(this.key) || '[]');
    const current = document.body.dataset.productHandle;
    const filtered = items.filter(i => i.handle !== current).slice(0, 4);

    if (!filtered.length) {
      this.container.closest('.recently-viewed-section')?.remove();
      return;
    }

    this.container.innerHTML = `<div class="product-grid">${filtered.map(p => {
      const tAttr = escAttr(p.title);
      const tHtml = escText(p.title);
      const u = p.url || '#';
      const imgSrc = p.img || '';
      return `
      <div class="product-card" data-product-url="${escAttr(u)}">
        <a href="${u}" class="product-card__link-overlay" tabindex="-1" aria-hidden="true"></a>
        <div class="product-card__media">
            <img src="${imgSrc}" alt="${tAttr}" loading="lazy" class="product-card__img product-card__img--main" draggable="false">
        </div>
        <div class="product-card__info">
          ${window.Stork?.designGermanyBadgeHtml ? window.Stork.designGermanyBadgeHtml() : ''}
          <div class="product-card__title"><a href="${u}" class="product-card__title-link">${tHtml}</a></div>
          <div class="product-card__price">
            <span class="price">${p.price ? window.Stork.formatMoney(parseInt(p.price, 10)) : ''}</span>
          </div>
        </div>
      </div>`;
    }).join('')}</div>`;
  }
}

/* ============================================================
   HIZLI SEPETE EKLE
   ============================================================ */
class ProductQuickAdd {
  constructor() {
    document.addEventListener('submit', e => {
      const form = e.target.closest('[data-quick-add-form]');
      if (!form) return;
      e.preventDefault();
      this.addToCart(form);
    });
  }

  async addToCart(form) {
    const variantId = form.querySelector('[name="id"]')?.value;
    if (!variantId) return;

    const btn = form.querySelector('[type="submit"]');
    if (btn) { btn.classList.add('loading'); btn.disabled = true; }

    try {
      await window.Stork.fetchJSON('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      window.Stork.emit('cart:updated');
      if (btn) {
        btn.textContent = 'Eklendi! ✓';
        setTimeout(() => {
          btn.textContent = 'Sepete Ekle';
          btn.classList.remove('loading');
          btn.disabled = false;
        }, 2000);
      }
    } catch (e) {
      if (btn) { btn.classList.remove('loading'); btn.disabled = false; }
    }
  }
}

/* ============================================================
   BAŞLAT
   ============================================================ */
document.addEventListener('DOMContentLoaded', () => {
  new AIRecommendations();
  new AISearch();
  new RecentlyViewed();
  new ProductQuickAdd();
});
